export const HTTP_ERROR_UNKNOWN = "UNKNOWN";
